// @flow
import React from "react";
import { withGlobalContext } from "../../common/GlobalContext";
import orderBy from "lodash/orderBy";
import filter from "lodash/filter";
import withStyles from "elevate-ui/withStyles";

import About from "./about-pod/About";
import HomeBlogList from "./home-blog-list/HomeBlogList";
import ListingGridFeatured from "./listing-grid-featured/ListingGridFeatured";
import FeaturedResources from "./featured-resources/FeaturedResources";
import FeaturedTowns from "./featured-towns/FeaturedTowns";
import ListingGridSpecial from "./listing-grid-special/ListingGridSpecial";
import HomeTestimonials from "./home-testimonials/HomeTestimonials";
import CustomPod from "./custom-pod/CustomPod";

import type {
  $BlogPosts,
  $Site,
  $LocalListingViewModel,
  Testimonials,
  $ListingWidgets,
} from "flow/types";

type $Props = {
  classes: Object,
  featuredListings: $LocalListingViewModel[],
  featuredListingsHeader: string,
  listingWidgets: $ListingWidgets,
  posts: $BlogPosts,
  site: $Site,
  testimonials: Testimonials,
  widgetInfo: Array<Object>,
  homepageFeaturedTownsHeroImage: string,
};

const Pods = ({
  site: {
    uiConfig: { pods },
  },
  classes,
  featuredListings,
  featuredListingsHeader,
  listingWidgets,
  posts,
  testimonials,
  widgetInfo,
  homepageFeaturedTownsHeroImage,
}: $Props) => {
  const homePods = orderBy(
    filter(pods, (pod) => {
      return /homepageA\d+/.test(pod.section);
    }),
    "section"
  );

  const renderPod = (pod: Object) => {
    switch (pod.value) {
      case "fullWidthAboutPhotoLeftDescriptionRight":
        return <About />;
      case "fullLengthMaterialDesignLike":
        return <HomeBlogList posts={posts} />;
      case "simpleLightFeaturedListingCard":
        return (
          <ListingGridFeatured
            title={featuredListingsHeader}
            listings={featuredListings}
          />
        );
      case "transparentCircleResources":
      case "originalBoxShapedResources":
      case "backgroundPhotoBoxShapedResources":
        return <FeaturedResources />;
      case "gridButtonsFeaturedTowns":
      case "mapCardsFeaturedTowns":
      case "grayGridListTowns":
      case "grayBackgroundGridFeaturedTowns":
        return (
          <FeaturedTowns
            homepageFeaturedTownsHeroImage={homepageFeaturedTownsHeroImage}
          />
        );
      case "simpleLightFeaturedListingCardSpecial":
        return (
          <ListingGridSpecial
            widgetInfo={widgetInfo}
            listingWidgets={listingWidgets}
          />
        );
      case "homepageTestimonialsSection":
        return <HomeTestimonials testimonials={testimonials} />;
      case "customPod":
        return <CustomPod html={pod.html} />;
      default:
        return null;
    }
  };
  return (
    <div className={classes.root}>
      {homePods.map((homePod, i) => (
        <section key={`pod${i}`} className={homePod.section}>
          {renderPod(homePod)}
        </section>
      ))}
    </div>
  );
};

const styles = (theme) => ({
  root: {
    "& > section:nth-child(even)": {
      backgroundColor: theme.colors.gray050,
    },
  },
});

export default withGlobalContext(withStyles(styles)(Pods));
